/* eslint-disable prettier/prettier */
/* eslint-disable no-unused-vars */
import React, { useState, useContext, useEffect } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { Helmet } from "react-helmet";
import LoginBackground from "../../assets/images/LoginBackground.png";
import LoginBackgroundFront from "../../assets/images/LoginBackgroundFront.png";
import Logo from "../../assets/images/Logo.svg";
import OTPInput from "../../components/OTPInput";
import Button from "../../components/Layout/Button";
import { SERVICES } from "../../components/Layout/Services";
import { get, post } from "../../components/Layout/ApiHandler/apihandler";
import { ROUTES } from "../../components/Routes";
import { ToastAlertContext } from "../../Config/Providers/ToastAlert";
import { AlertStatus } from "../../contants";

const Background = styled.div`
  background: url(${LoginBackground});
  background-size: 100% 100%;
  background-repeat: no-repeat;
  // width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  // padding: 112px 0px;
`;
const MainContainer = styled.div`
  display: flex;
  // border: 1px solid black;
  border-radius: 10px;
  width: 85%;
  // margin: 50px 0
`;
const LeftContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 50%;
  background: url(${LoginBackgroundFront});
  background-size: 100% 100%;
  // height: 80vh;
`;
const WelcomeText = styled.p`
  color: #eaeaeb;
  text-align: center;
  font-size: 48px;
  font-weight: 700;
  margin: 0 0;
`;
const ContributionText = styled.p`
  color: #fff;
  text-align: center;
  font-size: 40px;
  font-weight: 700;
  margin: 0 0;
`;
const RightContainer = styled.div`
  // display: flex;
  // flex-direction: column;
  // align-items: center;
  // justify-content: center;
  width: 50%;
  background: #fff;
  // border-radius: 10px;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  min-height: 500px;
`;
const OTPContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 100px auto auto auto;
  width: 70%;
`;
const OTPText = styled.p`
  color: #484848;
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  margin: 0 0;
  //   padding: 40px 0 30px 120px;
`;
const LoginName = styled.div`
  padding-left: 120px;
`;
const LoginNameText = styled.p`
  color: #484848;
  font-family: ITC Avant Garde Gothic Std;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  margin: 0 0;
`;
const LoginPassword = styled.div`
  // padding-left: 120px;
  padding: 25px 0 0 120px;
`;
const BtnContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  margin-top: 50px;
  // padding: 50px 0 0 120px;
`;

const NoteContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 25px auto auto auto;
  width: 65%;
  //   padding: 0px 100px 50px 120px;
`;

const NoteText = styled.p`
  color: #616060;
  font-size: 14px;
  font-weight: 400;
  margin: 0 0;
  .important-text {
    color: #df5c33;
    font-weight: 700;
  }
`;

const OTPInputConatiner = styled.div`
  margin-top: 40px;
`;

function OTPAuthentication() {
  const navigate = useNavigate();
  const [Otp, setOtp] = useState("");
  const toast = useContext(ToastAlertContext);
  const TITLE = "Enter OTP - BSG ContributionAdmin";
  const handleOTPChange = (otpValue) => {
    setOtp(otpValue);
  };
  const handleCancel = () => {
    localStorage.removeItem("X-Auth-Token");
    localStorage.removeItem("LoginTime");
    navigate(-1);
  };
  const handleMfaSubmit = async () => {
    const mfaUrl = SERVICES.OTP_AUTHENTICATION;
    const profileUrl = SERVICES.GET_PROFILE;

    try {
      const mfaResponse = await post(mfaUrl, { mfaCode: Otp });

      if (mfaResponse.ok) {
        const profileResponse = await get(profileUrl);

        if (profileResponse.ok) {
          const data = await profileResponse.json();
          if (
            data.data?.assignedRoles?.includes("contributionDataEntry") ||
            data.data?.assignedRoles?.includes("contributionOfflineDataEntry")
          ) {
            navigate(ROUTES.MEMBER_SEARCH);
          } else {
            navigate(ROUTES.DASHBOARD);
          }
        } else {
          toast.show(
            "OTP Authentication Failed. Please go back and try again.",
            AlertStatus.ERROR,
          );
          // console.log("Profile Request Failed");
        }
      } else {
        toast.show(
          "OTP Authentication Failed. Please go back and try again.",
          AlertStatus.ERROR,
        );
        // console.log("MFA Failed");
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };

  return (
    <>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>
      <Background>
        <MainContainer>
          <LeftContainer>
            <img src={Logo} alt="/logo" />
            <WelcomeText>Welcome</WelcomeText>
            <ContributionText>Contribution Admin</ContributionText>
            <span style={{ fontStyle: "italic", color: "white" }}>
              (Access to Chapter Statistics Incharges only)
            </span>
          </LeftContainer>
          <RightContainer>
            <OTPContainer>
              <OTPText>Enter 6 digit OTP Code</OTPText>
            </OTPContainer>
            <NoteContainer>
              <NoteText>
                A text message with a 6-digit verification code was just sent to
                your registered mobile no. and registered email id
              </NoteText>
            </NoteContainer>
            <OTPInputConatiner>
              <OTPInput onOTPChange={handleOTPChange} />
            </OTPInputConatiner>
            {/* <Button width="70%">Submit</Button> */}
            <BtnContainer>
              <Button width="70%" onClick={handleMfaSubmit}>
                Submit
              </Button>
              <Button width="70%" cancel onClick={handleCancel}>
                Back
              </Button>
            </BtnContainer>
          </RightContainer>
        </MainContainer>
      </Background>
    </>
  );
}

export default OTPAuthentication;
